import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2edc9d28"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_config"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "config_title"
}, "对话配置", -1));
const _hoisted_3 = {
  class: "boxs_conts"
};
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { getconfig_list, updateconfig_post, getmodel_list } from "@/service/modules/alllist";
export default /*#__PURE__*/_defineComponent({
  __name: 'config',
  setup(__props) {
    const form = reactive({
      id: "",
      default_model: "",
      content_count: 0,
      prompt: ""
    });
    const options = ref([]);
    const get_config = async () => {
      let res = await getmodel_list();
      options.value = res.data;
      let res2 = await getconfig_list();
      form.id = res2.data[0].id;
      form.default_model = res2.data[0].default_model;
      form.content_count = res2.data[0].content_count;
      form.prompt = res2.data[0].prompt;
    };
    get_config();
    const handleFooterBtn = async () => {
      let res = await updateconfig_post(form);
      if (res.code == 0) {
        get_config();
        ElMessage.success("保存成功");
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        model: form
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "默认模型",
          prop: "default_model",
          class: "label_edits"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            class: "input_1",
            modelValue: form.default_model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.default_model = $event),
            placeholder: " 请选择"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.cname,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "默认上下文条目数",
          prop: "content_count",
          class: "label_edits"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "inputs_c",
            modelValue: form.content_count,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.content_count = $event),
            type: "number",
            min: "0",
            placeholder: "请输入"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "默认角色预设",
          prop: "prompt",
          class: "label_edits"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "inputs_2",
            modelValue: form.prompt,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.prompt = $event),
            placeholder: "请输入"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "label_edits"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn())
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]);
    };
  }
});